/* src/app/shared/components/ag-communication-language/ag-communication-language.component.scss */
.language-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 16px;
  border: 2px solid #fff2f0;
  border-radius: 12px;
  background-color: #ffffff;
  width: 100%;
  cursor: pointer;
}
.language-container .header-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.language-container .header-container .language-header {
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
}
.language-container .header-container .language-header .language-icon {
  width: 20px;
  height: 20px;
}
.language-container .header-container .arrow-icon {
  width: 20px;
  height: 20px;
}
.language-container .header-container .up {
  transform: rotate(0deg);
}
.language-container .header-container .down {
  transform: rotate(180deg);
}
.language-container .divider {
  width: 100%;
  height: 1px;
  background-color: #dfdfdf;
}
.language-container .default-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.language-container .delete-container {
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  width: 100%;
  justify-content: flex-start;
}
.language-container .delete-container .trash-icon {
  width: 20px;
  height: 20px;
}
.language-container .delete-container .delete-button {
  color: #e55e5e;
  text-decoration: underline #e55e5e;
}
/*# sourceMappingURL=ag-communication-language.component.css.map */
